import React from 'react';
import {Container, Row, Col} from 'reactstrap';

import './updatePaymentStyle.scss';
import BasicText from './basicText';

const TVNotification = (props) => {
  return (
    <Container className='paymentupdate-notification-container'>
      <Row>
        <Col>
          <BasicText text='שימו לב' bold color={'privatePink'} />
        </Col>
      </Row>
      <Row>
        <Col>
          <BasicText text={`על מנת לחדש את הצפייה ב${window.Config.brand_Name_HE} TV יש לכבות ולהדליק את הממיר`} />
        </Col>
      </Row>
    </Container>
  );
};

export default TVNotification;
